import "./MergeFlow.scss";
import { Button } from "antd";

interface MergeFooterProps {
    readonly onCancel: () => void;
    readonly onMerge: () => void;
    readonly confirmation: boolean;
    readonly loading: boolean;
}

/** Footer that can be temporarily injected into the NewPaymentModal, replacing its native footer. */
export const MergeFooter = ({ onCancel, onMerge, confirmation, loading }: MergeFooterProps) => (
    <div className="merge-footer">
        {confirmation && (
            <>
                <header>Are you sure you want to merge this patient?</header>
                <Button type="default" htmlType="submit" value="cancelMerge" onClick={onCancel}>
                    Cancel
                </Button>
            </>
        )}
        <Button type="primary" htmlType="submit" value="merge" loading={loading} onClick={onMerge}>
            Merge
        </Button>
    </div>
);
